<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="inline">
      <h4 class="modal-title">
        {{ 'components.createIrTask.title' | translate }}
      </h4>
      @if (shouldRenderTooltip) {
        <app-tooltip [marginBottom]="false" text="createIrTask" />
      }
    </div>
    <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    @if (isCrudLoading) {
      <div class="lna-spinner">
        <app-spinner [isLoading]="isCrudLoading"></app-spinner>
      </div>
    }
    <form [formGroup]="form" [ngClass]="{ hidden: isCrudLoading }">
      <!-- Izpildītājs radio -->
      <div class="lna-row assignee-row">
        <label class="form-label lna">
          {{ 'components.createIrTask.assigneeType' | translate }}
          <span class="required-field">*</span>
        </label>
        <div class="radio-group">
          <label class="radio-label">
            <input
              type="radio"
              name="assigneeType"
              [checked]="assigneeType === 'user'"
              (change)="onAssigneeTypeChange('user')" />
            {{ 'components.createIrTask.assigneeUser' | translate }}
          </label>
          <label class="radio-label">
            <input
              type="radio"
              name="assigneeType"
              [checked]="assigneeType === 'structuralUnit'"
              (change)="onAssigneeTypeChange('structuralUnit')" />
            {{ 'components.createIrTask.assigneeStructuralUnit' | translate }}
          </label>
        </div>
      </div>

      <!-- Darbinieks / Struktūrvienība + Uzdevuma veids row -->
      <div class="lna-row two-columns">
        <div class="column">
          @if (assigneeType === 'user') {
            <label class="form-label lna">
              {{ 'components.createIrTask.assigneeUser' | translate }}
              <span class="required-field">*</span>
            </label>
            <app-search-user-input
              [invalid]="shouldRenderError('assigneeUserId')"
              (userSelected)="onUserSelected($event)" />
            @if (getErrorMessage('assigneeUserId'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message">{{ errorMessage | translate }}</small>
              </div>
            }
          } @else {
            <label class="form-label lna">
              {{ 'components.createIrTask.assigneeStructuralUnit' | translate }}
              <span class="required-field">*</span>
            </label>
            <select
              class="form-control lna"
              formControlName="assigneeStructuralUnitId"
              [ngClass]="{ invalid: shouldRenderError('assigneeStructuralUnitId') }">
              <option [ngValue]="null" disabled></option>
              @for (unit of structuralUnits; track unit.id) {
                <option [value]="unit.id">{{ unit.name }}</option>
              }
            </select>
            @if (getErrorMessage('assigneeStructuralUnitId'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message">{{ errorMessage | translate }}</small>
              </div>
            }
          }
        </div>
        <div class="column">
          <label class="form-label lna">
            {{ 'components.createIrTask.taskType' | translate }}
            <span class="required-field">*</span>
          </label>
          <select
            class="form-control lna"
            formControlName="taskTypeClassifierValueId"
            [ngClass]="{ invalid: shouldRenderError('taskTypeClassifierValueId') }">
            <option value="" disabled></option>
            @for (type of taskTypes; track type.id) {
              <option [value]="type.id">{{ type.name }}</option>
            }
          </select>
          @if (getErrorMessage('taskTypeClassifierValueId'); as errorMessage) {
            <div class="error-wrapper">
              <small class="error-message">{{ errorMessage | translate }}</small>
            </div>
          }
        </div>
      </div>

      <!-- Uzdevuma teksts -->
      <div class="lna-row full-width">
        <label class="form-label lna">
          {{ 'components.createIrTask.text' | translate }}
        </label>
        <div class="textarea-wrapper">
          <textarea
            class="form-control lna"
            formControlName="text"
            maxlength="{{ maxTextLength }}"></textarea>
          <p
            class="length"
            [ngClass]="{ invalid: form.get('text')?.value?.length > maxTextLength }">
            {{ form.get('text')?.value?.length || 0 }}/{{ maxTextLength }}
          </p>
        </div>
      </div>

      <!-- Izpildes secība + Izpildes datums -->
      <div class="lna-row two-columns">
        <div class="column">
          <label class="form-label lna">
            {{ 'components.createIrTask.executionOrder' | translate }}
            <span class="required-field">*</span>
          </label>
          <select
            class="form-control lna"
            formControlName="executionOrder"
            [ngClass]="{ invalid: shouldRenderError('executionOrder') }">
            @for (opt of executionOrderOptions; track opt) {
              <option [ngValue]="opt">{{ opt }}</option>
            }
          </select>
          @if (getErrorMessage('executionOrder'); as errorMessage) {
            <div class="error-wrapper">
              <small class="error-message">{{ errorMessage | translate }}</small>
            </div>
          }
        </div>
        <div class="column">
          <label class="form-label lna">
            {{ 'components.createIrTask.executionDate' | translate }}
            <span class="required-field">*</span>
          </label>
          <app-date-picker
            [date]="form.get('executionDate')?.value"
            [invalid]="shouldRenderError('executionDate')"
            [dateRangeMode]="DateRangeMode.FutureAndToday"
            (dateSelected)="onDateSelected($event)" />
          @if (getErrorMessage('executionDate'); as errorMessage) {
            <div class="error-wrapper">
              <small class="error-message">{{ errorMessage | translate }}</small>
            </div>
          }
        </div>
      </div>
    </form>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" [disabled]="isCrudLoading" (click)="submit()" type="button">
      {{ 'components.createIrTask.submit' | translate }}
    </button>
    <button class="secondary" (click)="close()" type="button">
      {{ 'components.createIrTask.cancel' | translate }}
    </button>
  </div>
</ng-template>
